import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

interface IRadioButton {
  label: string;
  id: string;
  options: Array<{value: string, label: string}>
}
export default function RadioButton(prop: IRadioButton) {
  return (
    <FormControl>
      <FormLabel style={{color: 'grey'}} id={prop.id}>{prop.label}</FormLabel>
      <RadioGroup
        name={prop.id}
      >
        {prop.options.map(option => (
           <FormControlLabel value={option.value}
           control={<Radio color="default" size='small'/>}
           label={option.label} />
        ))}
      </RadioGroup>
    </FormControl>
  );
}